import styled from 'styled-components';


const FlexColumnContainer = styled.div`
  min-height: calc(100vh - 297px);
`;


export default FlexColumnContainer;
